import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {unpackId} from 'common/diplomatIdUtil';
import {useDispatch} from 'react-redux';
import MoveDialog from 'features/layout/DialogRoutes/dialogs/MoveDialog';
import {synchronizationsActions} from 'redux/synchronizations';
import {DialogTypes} from 'common/names';

type Props = {
   data: INav;
   onClose: () => void;
};

const MoveSynchronizationDialog = ({data, onClose}: Props) => {
   const dispatch = useDispatch();
   const {id} = unpackId(data.id);

   const handleMove = (folderId: string) => {
      dispatch(
         synchronizationsActions.moveSynchronization([id], folderId, {
            onSuccess: onClose,
            onError: onClose,
         })
      );
   };

   return (
      <MoveDialog
         data={data}
         header={DialogTypes.MoveSynchronizationDialog.dialogName}
         onConfirm={handleMove}
         onClose={onClose}
      />
   );
};

export default MoveSynchronizationDialog;
